import React from 'react';
import styled from '@emotion/styled';
import { Consumer } from '@/store';
import footerImg from '@/images/footer-img.png';
export default (function () {
  return React.createElement(Consumer, null, function (store) {
    var _store$state = store.state,
      loading = _store$state.loading,
      quest = _store$state.quest;
    if (loading) return 'loading...';
    var _ref = quest || {},
      footer = _ref.footer,
      showFooter = _ref.showFooter,
      _ref$footerType = _ref.footerType,
      footerType = _ref$footerType === void 0 ? 'custom' : _ref$footerType;
    var defaultFooter = React.createElement("div", {
      className: "default-info"
    }, React.createElement("div", {
      className: "title"
    }, React.createElement("img", {
      src: footerImg
    }), "\u5B57\u8282\u95EE\u5377"), React.createElement("div", {
      className: "desc"
    }, "\u5B57\u8282\u95EE\u5377 Survey \u4EC5\u63D0\u4F9B\u6280\u672F\u652F\u6301"));
    return React.createElement(React.Fragment, null, !window.isReport && (showFooter || showFooter == undefined) && React.createElement(Footer, {
      dir: window.dir
    }, footerType === 'custom' ? React.createElement("p", {
      className: "footer-info"
    }, footer || '') : defaultFooter));
  });
});
var Footer = /*#__PURE__*/styled("footer", {
  target: "e1i236tb0"
})("text-align:center;margin-top:170px;.page-indicator{color:#666;}.footer-info{color:var(--text-color);text-shadow:0 2px 2px #fff;}.default-info{padding:24px 0;.title{display:flex;align-items:center;justify-content:center;font-weight:500;font-size:13px;color:var(--text-color);img{margin-right:4px;width:16px;}}.desc{margin-top:8px;font-weight:400;font-size:12px;color:rgba(22,24,35,0.34);}}");